import { useEffect, useState } from "react";
import { api, fmtTs } from "../api";
import { Card, CardContent, Badge } from "../components/ui";

const STATUS_COLORS = {
  PENDING: "bg-white/10 text-white/80",
  GENERATING: "bg-blue-500/20 text-blue-300",
  READY: "bg-amber-500/20 text-amber-300",
  QUEUED: "bg-purple-500/20 text-purple-300",
  PLAYING: "bg-red-500/20 text-red-300",
  PLAYED: "bg-green-500/20 text-green-300",
  FAILED: "bg-red-500/20 text-red-300",
  CANCELLED: "bg-white/5 text-gray-500",
};

const TYPE_LABELS = {
  FIRST_CALL: "10 min",
  SECOND_CALL: "5 min",
  FINAL_CALL: "Largada",
  MANUAL: "Manual",
  REPLAY: "Replay",
};

export default function History() {
  const [items, setItems] = useState([]);
  const load = async () => {
    try { const r = await api.get("/announcements?limit=200"); setItems(r.data); } catch { }
  };
  useEffect(() => { load(); const id = setInterval(load, 5000); return () => clearInterval(id); }, []);

  return (
    <div>
      <h1 className="font-display text-4xl uppercase leading-none mb-6">Histórico de Chamadas</h1>
      <Card>
        <CardContent className="p-0">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="text-[10px] uppercase tracking-widest text-gray-500 border-b border-panel">
                <tr>
                  <th className="text-left p-3">Status</th>
                  <th className="text-left p-3">Tipo</th>
                  <th className="text-left p-3">Sessão</th>
                  <th className="text-left p-3">Agendado</th>
                  <th className="text-left p-3">Reproduzido</th>
                  <th className="text-left p-3">Mensagem</th>
                </tr>
              </thead>
              <tbody>
                {items.map((a) => (
                  <tr key={a.id} className="border-b border-panel hover:bg-white/5">
                    <td className="p-3"><Badge className={STATUS_COLORS[a.status] || "bg-white/5"}>{a.status}</Badge></td>
                    <td className="p-3 uppercase text-[10px] tracking-widest text-gray-400">{TYPE_LABELS[a.announcement_type] || a.announcement_type}</td>
                    <td className="p-3 font-mono-data text-xs text-gray-500">#{a.session_id?.slice(0, 14)}</td>
                    <td className="p-3 text-xs text-gray-400">{fmtTs(a.scheduled_at)}</td>
                    <td className="p-3 text-xs text-gray-400">{fmtTs(a.played_at)}</td>
                    <td className="p-3 text-xs text-gray-500 max-w-md truncate">{a.message || "—"}</td>
                  </tr>
                ))}
                {items.length === 0 && (
                  <tr><td colSpan={6} className="p-8 text-center text-gray-500">Nenhuma chamada ainda.</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
